import { Toaster } from "@/components/ui/sonner";

export const ToastsProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <>
      {children}
      <Toaster />
    </>
  );
};
